module.exports = __webpack_public_path__ + "img/公司业务—审计.f58e20e0.jpg";